import classNames from 'classnames';

import { usePermissions } from '../../../hooks/usePermissions';
import { ApiPermissions } from '../../../constants/api-permissions';
import SubscriptionStatus from '../../../constants/subscription.status';

import styles from './subscription-details-popover.module.scss';

const POSSIBLE_ACTIVE_STATUS = [
    SubscriptionStatus.ACTIVE,
    SubscriptionStatus.SUSPENDED,
];

export enum SubscriptionAction {
    UPDATE_DATA = 'UPDATE_DATA',
    SUSPEND = 'SUSPEND',
    INACTIVATE = 'INACTIVATE',
}

interface Props {
    shown: boolean;
    top: number;
    subscriptionStatus?: number;
    isDeleted?: boolean;
    onDiscard: () => void;
    onAction: (action: SubscriptionAction) => void;
}

const SubscriptionDetailsPopover = ({
    shown,
    top,
    subscriptionStatus,
    isDeleted,
    onAction,
    onDiscard,
}: Props) => {
    const { hasPermission } = usePermissions();

    const isActive = subscriptionStatus
        ? POSSIBLE_ACTIVE_STATUS.includes(subscriptionStatus)
        : false;
    const isSuspended = subscriptionStatus === SubscriptionStatus.SUSPENDED;

    const canSuspend =
        !isDeleted && hasPermission(ApiPermissions.SUSPEND_SUBSCRIPTIONS);
    const canUpdate =
        !isDeleted && hasPermission(ApiPermissions.UPDATE_SUBSCRIPTIONS);
    const canCancel =
        !isDeleted && hasPermission(ApiPermissions.CANCEL_SUBSCRIPTIONS);

    const disabledTitle = isDeleted
        ? 'La suscripción está eliminada'
        : 'No tiene permisos para realizar esta acción';

    return (
        <div>
            <div
                className={classNames({
                    [styles.subscriptionPopoverOverlay]: true,
                    [styles.shown]: shown,
                })}
                onClick={onDiscard}
            />
            <div
                className={classNames({
                    [styles.subscriptionMoreDetailsPopover]: true,
                    [styles.shown]: shown,
                })}
                style={{ top }}
            >
                <ul>
                    <li
                        className={
                            !isActive || !canSuspend
                                ? styles.disabled
                                : undefined
                        }
                        title={!canSuspend ? disabledTitle : undefined}
                    >
                        <a
                            onClick={() =>
                                isActive &&
                                canSuspend &&
                                onAction(SubscriptionAction.SUSPEND)
                            }
                        >
                            {isSuspended ? 'Reanudar' : 'Pausar'} suscripción
                        </a>
                    </li>
                    <li
                        className={!canUpdate ? styles.disabled : undefined}
                        title={!canUpdate ? disabledTitle : undefined}
                    >
                        <a
                            onClick={() =>
                                canUpdate &&
                                onAction(SubscriptionAction.UPDATE_DATA)
                            }
                        >
                            Actualizar suscripción
                        </a>
                    </li>
                    <div className={styles.separator} />
                    <li
                        className={
                            !isActive || !canCancel
                                ? styles.disabled
                                : undefined
                        }
                        title={!canCancel ? disabledTitle : undefined}
                    >
                        <a
                            className={styles.danger}
                            onClick={() =>
                                canCancel &&
                                onAction(SubscriptionAction.INACTIVATE)
                            }
                        >
                            Cancelar suscripción
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export { SubscriptionDetailsPopover };
